import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react'
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import messages from './ElectricalComponent.messages';
import metadata from './ElectricalComponent.metadata.json5';
import styles from '../Construction.module.scss';

/**
 * 2024-07-29 - Debra Frum -  US28798 - TFPA Res Quote - Construction - Electrical - HomeOwners
 *                            US26827 - TFPA Res Quote - Construction - Electrical - Dwelling
 * 
 * @param {*} props 
 * @returns
 */

function ElectricalComponent(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate} = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('electrical');
    const { refreshData } = useDataRefresh();
    const constructionPath = 'lobData.homeowners_tfpa.coverables_Ext.construction';
    const construction = _.get(submissionVM, constructionPath);
    const [wiringUpdatedCheckBox, setWiringUpdatedCheckBox] = useState(false);
    const [alWiringProUpdated, setAlWiringProUpdated] = useState();
    const policyType = _.get(submissionVM, constructionPath);

    const getWiringType = useMemo(() => {
        const WiringTypeList = viewModelService?.productMetadata?.get('pc').types.getTypelist('WiringType_HOE');
        const formattedTypes =  WiringTypeList?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }))
        return formattedTypes
    },[translator, viewModelService?.productMetadata]);

    const getBreakerType = useMemo(() => {
        const BreakerTypeList = viewModelService?.productMetadata?.get('pc').types.getTypelist('BreakerType_HOE');
        const formattedTypes =  BreakerTypeList?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }))
        return formattedTypes
    },[translator, viewModelService?.productMetadata]);

   const getAmperageType = useMemo(() => {
        const AmerageTypeList = viewModelService?.productMetadata?.get('pc').types.getTypelist('AmperageType_ext');
        const formattedTypes =  AmerageTypeList?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }))
        return formattedTypes
    },[translator, viewModelService?.productMetadata]);

    useEffect(() => {
        const wiringUpgradeExists = _.get(construction, 'wiringUpgradeExists.value') === true;
        _.set(construction,`wiringUpgradeExists.value`, wiringUpgradeExists);
        setWiringUpdatedCheckBox(wiringUpgradeExists);

    },[])

   useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'Electrical');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'Electrical');
    }, [findInvalidComponent, isComponentValid])


    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true,
            readOnly: true
        },
        wiringType: {
            visible: true,
        },
        alWiringProUpdated: {
            visible: construction.wiringType?.value?.code === 'aluminum'
        },
        electricalType: {
            visible: true,
        },
        amperageType: {
            visible: true,
        },
        wiringUpdates: {
            visible: true
        },
        wiringUpdateYear: {
            visible: construction.wiringUpgradeExists?.value
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {}
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={construction}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

export default ElectricalComponent;